import { useRef } from 'react';
import { getWebsocketConnection } from '../util';

export default (websocketUrl, onMessage, onError) => {
  const connection = useRef();

  const onMessageRef = useRef();
  onMessageRef.current = onMessage;

  const onErrorRef = useRef();
  onErrorRef.current = onError;

  // try to connect to server if not already connected, return if connected successfully as a boolean value
  const ensureConnection = async () => {
    if (!connection.current || connection.current.readyState > 1) {
      try {
        connection.current = await getWebsocketConnection(websocketUrl);
        connection.current.onmessage = msg => {
          try {
            const msgJson = JSON.parse(msg.data);
            onMessageRef.current(msgJson);
          } catch (error) {
            // ignore failed messages in case the server sent non json message
            console.error('CapAskAira error parsing socket message, ', error);
          }
        };
      } catch (error) {
        console.error('CapAskAira error connecting to websocket, ', error);
        onErrorRef.current(error);
        return false;
      }
    }
    return true;
  };

  const sendMessage = async msg => {
    const connected = await ensureConnection();
    if (!connected) return;
    connection.current.send(JSON.stringify(msg));
  };

  const resetConnection = () => {
    if (connection.current) {
      connection.current.close();
      connection.current = null;
    }
  }

  return { sendMessage, resetConnection };
}
